import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e47d638485e20014242167/vesselaudit/src/app/open-inspections/components/OpenInspectionsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e47d638485e20014242167/vesselaudit/src/components/AppLayout.tsx");
